module.exports = __webpack_public_path__ + "static/media/buy_req_teach_actual.d26fb3d6.png";